<template>
    <div class="switch-port-search relative w-full">
        <div class="form-input-with-icon relative">
            <input
                v-model="query"
                type="text"
                :name="type"
                class="bg-white text-neutral-darker form-input"
                :placeholder="typeToPlaceholderMap[type]"
                autocomplete="off"
                @keydown.down="down"
                @keydown.up="up"
                @keydown.enter="hit"
                @keydown.esc="reset"
                @input="search"
            >
            <font-awesome-icon
                v-if="isDirty && ! loading"
                icon="times"
                class="cursor-pointer"
                @click="reset"
            />
            <font-awesome-icon
                v-if="loading"
                icon="spinner"
                spin
                pulse
            />
        </div>

        <ul
            v-show="hasItems && ! errorStatus"
            class="search-results"
        >
            <li
                v-for="(item, index) in items"
                class="flex"
                @mousedown="hit"
                @mousemove="setActive(index)"
            >
                <span class="name" v-text="`${item}`" />
            </li>
        </ul>

        <div v-if="loading && ! errorStatus" class="text-center mt-2xl mb-sm">
            <div class="loader-spin" />
        </div>

        <div
            v-if="errorStatus"
            class="p-md text-left absolute z-10 text-black bg-white rounded w-full mt-sm shadow"
        >
            <span v-if="errorStatus === 429">
                Det verkar som att du sökt lite för mycket, om du väntar en minut
                bör du kunna söka igen.
            </span>
            <span v-else>
                Någonting gick fel, försök igen lite senare.
            </span>
        </div>
    </div>
</template>
<script>
    import VueTypeahead from '../../../shared/components/VueTypeahead.vue';
    import ClickOutside from 'vue-click-outside';

    export default {
        directives: {
            ClickOutside,
        },

        extends: VueTypeahead,

        props: {
            address: {
                required: true,
                type: Object,
            },
            defaultQuery: {
                required: false,
                type: [Number, String],
                default: () => {
                    return '';
                },
            },
            type: {
                type: String,
                default: () => {
                    return 'Switchport';
                },
            },
        },

        data() {
            return {
                limit: 20,
                loading: false,
                minChars: 2,
                selectFirst: true,
                src: this.type === 'node'
                    ? route('api.delivery-projects.addresses.switch-port.nodes', this.address)
                    : this.type === 'switch'
                        ? route('api.delivery-projects.addresses.switch-port.switches', this.address)
                        : '',
                typeToPlaceholderMap: {
                    node: 'Nod',
                    switch: 'Switch',
                },
                query: this.defaultQuery,
            };
        },

        created() {
            setTimeout(function () {
                if ('createEvent' in document) {
                    var element = document.querySelector('.switch-port-search input[name=switch]');

                    if (! element) return;
                    if (element.value.length > 2) return;

                    var event = document.createEvent('HTMLEvents');

                    event.initEvent('input', false, true);

                    element.dispatchEvent(event);
                }
            });
        },

        methods: {
            onHit(item) {
                if (! item) {
                    return;
                }

                this.items = [];
                this.query = item;
            },

            async search() {
                this.update();
            },

            activeClass(index) {
                return {
                    'text-accent-peach-darker': this.current === index,
                };
            },
        },
    };
</script>
